import { FormattedMessage } from 'react-intl';

import TimestampAndMileage from '@/features/engineoil/components/TimestampAndMileage';
import { isVehicleModelOlderThan2022 } from '@/features/engineoil/utils/utils';
import { ModelYear } from '@/generated/GeneratedApiTypes';

interface HeaderProps {
    timestamp: string | undefined;
    mileage: number | undefined;
    isReadingNotPossible?: boolean;
    modelYear?: ModelYear;
}

const Header = ({ timestamp, mileage, isReadingNotPossible = false, modelYear }: HeaderProps) => {
    const hasReading = timestamp != null || mileage != null;

    return (
        <div className="display-flex align-items-baseline gap-10">
            <h6 className="text-uppercase text-color-dark margin-0">
                <FormattedMessage id="intl-msg:engineOil.fillLevel.title" />
            </h6>
            {!isVehicleModelOlderThan2022(modelYear) && hasReading && (
                <span className="text-size-14 text-color-gray" style={{ display: 'inline-flex' }}>
                    {isReadingNotPossible && <FormattedMessage id="intl-msg:engineOil.latestValidReading" />}
                    <span className="margin-left-4">
                        <TimestampAndMileage timestamp={timestamp} mileage={mileage} textColor="gray" />
                    </span>
                </span>
            )}
        </div>
    );
};

export default Header;
